import { forEach, get } from 'lodash';

export default function ProductionDetails(responses) {
  const titleMapping = {
    // Skip because not passed through main call and we don't use it
    inv_no: null,
    description: 'Description',
    // Not accurate, but we don't use it
    type: 'InventoryType',
    short_name: 'ShortName',
    text1: 'Text1',
    text2: 'Text2',
    text3: 'Text3',
    text4: 'Text4',
    // _Think_ this is next performance, but we don't use it
    perf_dt: null,
  };

  const productionMapping = {
    prod_season_no: 'Id',
    prod_no: 'Production.Id',
    title_no: null,
    duration: null,
    lang: null,
    cost: null,
    synop: null,
    num_acts: null,
    create_loc: 'CreatedBy',
    created_by: 'CreateLocation',
    create_dt: 'CreatedDateTime',
    era: null,
    orig_lang: null,
    lib: null,
    author: null,
    orig_synop: null,
    LangDesc: null,
    composerID: null,
    ComposerFN: null,
    ComposerMN: null,
    ComposerLN: null,
    bio: null,
    inactive: false,
    facility_desc: null,
  };

  const performanceMapping = {
    pkg_no: null,
    perf_no: 'Id',
    pkg_code: null,
    perf_code: 'Code',
    perf_date: 'Date',
    gross_availability: null,
    availability_by_customer: null,
    facility_no: 'Facility.Id',
    met_criteria_ind: null,
    time_slot: 'TimeSlot.Id',
    description: 'Description',
    on_sale_ind: 'AvailSaleIndicator',
    bu: null,
    prod_season_no: 'ProductionSeason.Id',
    no_name: null,
    zmap_no: 'ZoneMap.Id',
    start_dt: 'DefaultStartSaleDateTime',
    end_dt: 'DefaultEndSaleDateTime',
    first_dt: null,
    last_dt: null,
    facility_desc: 'Facility.Description',
    weight: null,
    super_pkg_ind: null,
    fixed_seat_ind: null,
    flex_ind: null,
    prod_type: 'Type.Id',
    prod_type_desc: 'Type.Description',
    season_no: 'Season.Id',
    season_desc: 'Season.Description',
    perf_status: 'Status.Id',
    perf_status_desc: 'Status.Description',
    relevance: null,
    premiere_id: null,
    premiere_desc: null,
    time_slot_desc: 'TimeSlot.Description',
  };

  const mapped = {
    Title: {},
    Production: {},
    Performance: [],
    Credit: [],
    // We don't use these
    WebContent: [],
    // We don't use these
    PerformanceWebContent: [],
  };

  const [ productionDetails, performancesResponse ] = responses;

  forEach(titleMapping, (property, key) => {
    if (property === null || property === false) {
      mapped.Title[key] = property;
    } else {
      mapped.Title[key] = get(productionDetails.result, property, null);
    }
  });

  forEach(productionMapping, (property, key) => {
    if (property === null || property === false) {
      mapped.Production[key] = property;
    } else {
      mapped.Production[key] = get(productionDetails.result, property, null);
    }
  });

  performancesResponse.result.forEach(perf => {
    const performance = {};

    forEach(performanceMapping, (property, key) => {
      if (property === null || property === false) {
        performance[key] = property;
      } else {
        performance[key] = get(perf, property, null);
      }
    });

    mapped.Performance.push(performance);
  });

  return mapped;
}



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/ProductionDetail.js